import {Injectable} from '@angular/core';
import {SecureApi} from '../core/secure.api';

@Injectable()
export class SupportService {
    constructor(public secureApi: SecureApi) {
    }

    getContent(language) {
        return this.secureApi.get('support-center/index/' + language);
    }

    countView(params) {
        return this.secureApi.post('support-center/count-view', params, false);
    }

    getReleaseNotes(language) {
        return this.secureApi.get('support-center-release-note/index/' + language);
    }
}
